import { render, staticRenderFns } from "./termsList.vue?vue&type=template&id=a8d14382&scoped=true"
import script from "./termsList.vue?vue&type=script&lang=js"
export * from "./termsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d14382",
  null
  
)

export default component.exports